
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { BLUE } from "resources/Colors";
import useI18n from "state/i18n";
import BaseDialog from "./BaseDialog";

import Inactive86Label from "./Product/components/Inactive86Label";
import VariantRow from "./Product/components/VariantRow";


const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
  margin-bottom: 27px;
`;

const ProductTitle = styled.span`
  font-size: 16px/19px;
  font-weight: bold;
  @media only screen and (max-width: 440px) {
    font-size: 1.2rem;
  }
`;

const DialogTitle = styled.span`
  font: normal normal normal 16px/19px Montserrat;
  @media only screen and (max-width: 440px) {
    font-size: 1.2rem;
  }
`;

const Price = styled.span`
  vertical-align: middle;
  display: inline-block;
  line-height: 27px;
`;

const Content = styled.div`
  padding: 1rem 1.5rem;
  position: relative;
`;

const ButtonWrapper = styled.div`
  width: 100%;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
`;

const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  background-color: ${BLUE};
  border-radius: 6px;
  height: 100%;
  width: 12rem;
  border: none;
  box-shadow: 0px 8px 24px #0332693D;
`;

const VariantContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr; 
  align-items: center;
  gap: 25px; 
  margin-bottom: 50px;
  width: 100%;
`;

const DialogTitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
  margin-top: 32px;
  margin-bottom: 40px;
`;

export default function VariantSelectionDialog({ open, onClose, handleMultipleOrders, product }) {
  const currOrder = useMemo(() => {
    return product.variants?.reduce((acc, curr) => {
      acc[curr.id] = product.amounts?.find(a => +a.id === +curr.id)?.count || 0;
      return acc;
    }, {});
  }, [product]);
  const [order, setOrder] = useState({});
  useEffect(() => currOrder && setOrder(currOrder), [currOrder]);

  const [i18n] = useI18n();
  const is86Inactive = ((!!product && product.status === 'active' && product.stockTotal === 0) ? true : false);

  const handleAdd = () => {
    handleMultipleOrders(order);
    onClose();
  }

  return (
    <BaseDialog open={open} onClose={onClose} style={{borderRadius: '16px'}}>
      <Content>
        <DialogTitleContainer>
          <DialogTitle>{i18n.tag("MAKE_YOUR_SELECTION")}</DialogTitle>
        </DialogTitleContainer>

        <TitleContainer>
          <ProductTitle>{product?.title}</ProductTitle>
          {
            product?.variants?.length < 2 && <Price>{product?.config?.marketPrice ? 'MKT' : `$${product?.variants[0].price}`}</Price>
          }
        </TitleContainer>
        {
          product?.variants?.length > 1 && (
            <VariantContainer>
              {
                product?.variants.map((variant) => !!variant.active && (
                  <VariantRow variant={variant} order={order} setOrder={setOrder} />
                ))
              }
            </VariantContainer>
          )
        }
        {is86Inactive ? (
          <Inactive86Label />
        ) : (
          <ButtonWrapper>
            <Button onClick={handleAdd}>{i18n.tag("ADD_SELECTION")}</Button>
          </ButtonWrapper>
        )}
      </Content>
    </BaseDialog>
  );
}
